export default "__VITE_ASSET__DWRoWizO__"